import React from 'react'

import { StyledDropdownItem } from './styled'

import { DropdownItemComponent, DropdownItemProps } from './Dropdown.types'

const DropdownItem: DropdownItemComponent = ({ isActive, ...props }: DropdownItemProps) => {
  return <StyledDropdownItem {...props} isActive={isActive} />
}

export default DropdownItem
